/**
 * Section Component
 * Displays content sections with optional icons
 */

import React from 'react';
import ReactMarkdown from 'react-markdown';

export interface SectionData {
  title: string;
  content: string;
  icon?: string;
  type?: 'default' | 'info' | 'success' | 'warning' | 'error';
}

interface SectionProps {
  section: SectionData;
}

export const Section: React.FC<SectionProps> = ({ section }) => {
  const { title, content, icon, type = 'default' } = section;

  return (
    <div className={`ai360-section ai360-section-${type}`}>
      <div className="ai360-section-header">
        {icon && (
          <span className="ai360-section-icon" role="img" aria-label="icon">
            {icon}
          </span>
        )}
        <h3 className="ai360-section-title">{title}</h3>
      </div>
      <div className="ai360-section-content">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    </div>
  );
};

interface SectionsListProps {
  sections: SectionData[];
}

export const SectionsList: React.FC<SectionsListProps> = ({ sections }) => {
  if (!sections || sections.length === 0) {
    return null;
  }

  return (
    <div className="ai360-sections-list">
      {sections.map((section, index) => (
        <Section key={index} section={section} />
      ))}
    </div>
  );
};
